module.exports = __webpack_public_path__ + "static/media/smartphone.c7f5de30.png";